import axios from "axios";

import { NAVIGATION_PAGE_SIZE } from "consts";
import { DataGridRequestParams } from "types";

export interface NavigationRequests {
  total: number;
  requestNumbers: string[];
}

export interface RequestListInfo {
  isPresent: boolean;
  currentIndex: number | null;
}

export const getNavigationRequests = (
  _key: string,
  requestParams: DataGridRequestParams,
  page = 1
): Promise<NavigationRequests> =>
  axios
    .post<NavigationRequests>("pickupRequests/getPickupRequestsIds", {
      ...requestParams,
      limit: NAVIGATION_PAGE_SIZE,
      skip: NAVIGATION_PAGE_SIZE * (page - 1),
    })
    .then((res) => res.data);

export const getRequestListInfo = (
  requestNumber: string,
  requestParams: DataGridRequestParams
): Promise<RequestListInfo> =>
  axios
    .post<RequestListInfo>("pickupRequests/getPickupRequestListInfo", {
      requestNumber,
      ...requestParams,
    })
    .then((res) => res.data);
